module.exports = __webpack_public_path__ + "assets/447e69a4cfcd718b9976a560ba9ed20b.png";